import { Flex } from 'antd'
import Styles from './style.module.scss'

const TITLE = 'Our Company'

export default function Banner() {
  return (
    <Flex align='center' justify='center' className={Styles.banner}>
      <h1>{TITLE}</h1>
    </Flex>
  )
}
